import { render, staticRenderFns } from "./ArpHub.vue?vue&type=template&id=516ecd8b&scoped=true&"
import script from "./ArpHub.vue?vue&type=script&lang=js&"
export * from "./ArpHub.vue?vue&type=script&lang=js&"
import style0 from "./ArpHub.vue?vue&type=style&index=0&id=516ecd8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516ecd8b",
  null
  
)

export default component.exports